module.exports = __webpack_public_path__ + "static/media/logo.894d739d.png";